import Http from '../common/http';

const SettingService = {
  getList() {
    return Http.get(`/setting/list`);
  },
  update(data) {
    return Http.post(`/setting/${data.id}`, data);
  },
};

export default SettingService;
